/* eslint-disable camelcase */
import React, { useEffect, useContext } from "react";

import { useSelector } from "react-redux";

import { useLocation } from "react-router-dom";
import Dengage from "services/Dengage";

import CustomerContext from "../../contexts/CustomerContext";

import type { RootState } from "../../store/configureStore";


type PageViewTrackerProps = {
  children?: React.ReactNode;
};

export default function PageViewTracker({ children }: PageViewTrackerProps) {

  const location = useLocation();
  const customerDetails = useContext(CustomerContext);
  const initInProgress = useSelector((state: RootState) => state.app.initInProgress);

  const { pathname } = location;
  const customerStatus = customerDetails?.status;

  useEffect(() => {
    const sendDengagePageViewEvent = () => {
      if (initInProgress) return;
      Dengage.send(customerStatus, "sendDeviceEvent", "page_view_events", {
        page_url: window.location.href
      });
    };

    sendDengagePageViewEvent();
  }, [ pathname, initInProgress, customerStatus ]);

  useEffect(() => {
    if (initInProgress) return;
    Dengage.setNavigation();
  }, [ pathname, initInProgress ]);

  return (
    <>
      {children}
    </>
  );
}
